<script setup>
import LastUpdated from '@/components/layouts/LastUpdated.ce.vue';
import SectionNavigation from '@/components/layouts/SectionNavigation.ce.vue';
import SectionProgress from '@/components/layouts/SectionProgress.ce.vue';

import DebugSection from '@/components/sections/DebugSection.ce.vue';
import ChooserSection from '@/components/sections/ChooserSection.ce.vue';
import RegionalTariffSection from '@/components/sections/RegionalTariffSection.ce.vue';
import PersonalizedTariffsSection from '@/components/sections/PersonalizedTariffsSection.ce.vue';

import { useChooserFormStore } from '@/store/forms/chooser';
import { useSectionStore } from '@/store/sections';
import { watchers } from '@/watchers';
import { storeToRefs } from 'pinia';
import { useTranslationsStore } from '@/store/translations';
import { Spinner } from 'flowbite-vue';
import { ref } from 'vue';
import logUtils from '@/utils/logger';

const props = defineProps({
    locale: {
        type: String,
        default: 'en_PK',
    },
});

watchers.setup();

const formStore = useChooserFormStore();
const { debug } = storeToRefs(formStore);

const translationStore = useTranslationsStore();
const { isReady } = storeToRefs(translationStore);

const sectionStore = useSectionStore();
const { current: currentSection } = storeToRefs(sectionStore);

const debugParams = new URLSearchParams(window.location.hash.substring(1));
if (debugParams.get('debug') !== null) {
    formStore.$patch({
        debug: true,
    });
}

const debugLocale = debugParams.get('locale');

if (debugLocale) {
    translationStore.$patch({
        locale: debugLocale,
    });
} else {
    translationStore.$patch({
        locale: props.locale,
    });
}

const scrollTarget = ref();
sectionStore.$subscribe(() => {
    scrollTarget.value.scrollIntoView({ behavior: 'smooth' });
});
// const buildInfo = [
//     { label: 'Build Version:', value: window.APP_VERSION },
//     { label: 'Build Date:', value: window.BUILD_DATE },
//     { label: 'Build Mode:', value: process.env.NODE_ENV },
// ];

logUtils.logLogo();
// KC: Broken on production build
// logUtils.logBuildInfo(buildInfo);
</script>

<template>
    <div v-if="isReady" ref="scrollTarget">
        <DebugSection v-if="debug" />
        <SectionProgress />

        <ChooserSection v-if="currentSection === 1" />

        <RegionalTariffSection v-if="currentSection === 2" />
        <PersonalizedTariffsSection v-if="currentSection === 3" />

        <SectionNavigation />

        <LastUpdated />
    </div>
    <div v-else class="flex justify-center my-12">
        <Spinner size="12" />
    </div>
</template>

<style>
@import url('../style.css');
</style>
